import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, data: any) =>
  axios.post(
    `${process.env.REACT_APP_API_HOST}/admin/upload`,
    data,
    config(token)
  );
